module.exports = __webpack_public_path__ + "img/infoOrange.026a2b2a.png";